<template>
  <div class="txn-wrap">
    <div id="tx-trend" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
export default {
  name: 'TxnLine',
  data() {
    return {
      chart: null,
      intervalId: null,
      option: {
        xAxis: {
          type: 'category',
          data: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
          axisLine: {
            // 调整轴线颜色
            lineStyle: {
              color: '#306269'
            }
          },
          axisTick: {
            // 去掉刻度
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
              // fontWeight: 'bold'
            }
          },
          splitLine: {
            axisLabel: {
              textStyle: {
                color: 'green' // 设置为绿色
              }
            },
            lineStyle: {
              color: '#306269',
              width: 0.5
            }
          }
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: 'none',
            symbol: 'none',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFCC00' },
                { offset: 1, color: '#4E4810' }
              ])
            },
            label: {
              show: true
            },
            lineStyle: {
              color: '#FFCC00',
              width: 2,
              type: 'solid'
            }
          }
        ]
      }
    }
  },
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },
  mounted() {
    this.initChart()
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 10000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },
  methods: {
    initChart() {
      let container = document.getElementById('tx-trend')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },
    getData() {
      let cid = this.$store.state.home.chainCid
      this.$apis.home.getTxnLine({ chainId: cid }).then(res => {
        if (res.data) {
          let result = this.handleLine(res.data)
          this.chart.setOption({
            xAxis: {
              data: result[0].reverse()
            },
            series: [
              {
                data: result[1].reverse()
              }
            ]
          })
        }
      })
    },
    handleLine(data) {
      let hour = []
      let num = []
      data.map(ele => {
        let time = this.format(ele.Hourtime)
        hour.push(time)
        num.push(ele.Num)
      })
      return [hour, num]
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(h) + ':' + this.add0(mm)

      // return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.real-wrap,
.line-chart {
  @include px2vw(width, 800);
  @include px2vw(height, 330);
}
</style>
